import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6175 5.3749L14.5058 3.19307C14.7735 2.83782 14.8167 2.36882 14.6178 1.97041C14.4189 1.57199 14.0193 1.32466 13.5736 1.32466L3.90365 1.32446C2.61681 1.32446 1.57031 2.37096 1.57031 3.6578L1.57031 14.4164C1.57031 14.739 1.83165 14.9997 2.15365 14.9997C2.47565 14.9997 2.73698 14.739 2.73698 14.4164V9.33569L13.5742 9.33589C14.0199 9.33589 14.4195 9.08797 14.6184 8.69014C14.8173 8.2923 14.7741 7.8233 14.5064 7.46747L12.6175 5.3749ZM2.73698 8.16903L2.73698 3.6578C2.73698 3.01438 3.26023 2.49113 3.90365 2.49113L13.5742 2.49132L11.4217 5.02373C11.2654 5.2314 11.2654 5.51782 11.4217 5.72548L13.5742 8.16864L2.73698 8.16903Z"
      fill="#151718"
    />
  </svg>
);

const FlagIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default FlagIcon;
